import $axios from '~/plugins/axios';

import { Api, CampaignSplit, CampaignSplitRequest } from '~/api';
import type { GetCampaignSplitIdDistributionListEghParams, GetCampaignSplitIdDistributionListParams, GetCampaignSplitParams } from '~/api';
import { buildModule } from '../utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		splitById: {} as Dict<CampaignSplit>,
		currentId: null as number | null,
		loading: false as boolean,
	})
	.withGetters({
		byId: (state) => (id: number): CampaignSplit | null => state.splitById[id] ?? null,
		current: (state) => (state.currentId != null ? state.splitById[state.currentId] ?? null : null),
		loading: (state) => state.loading,
	})
	.withMutations({
		SET_SPLIT (state, value: CampaignSplit) {
			state.splitById = { ...state.splitById, [value.id]: value };
		},
		SET_CURRENT_ID (state, id: number | null) {
			state.currentId = id;
		},
		SET_LOADING (state, value: boolean) {
			state.loading = value;
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			commit('SET_LOADING', true);
			const { data } = await api.get(`/campaign-split/${ id }`);
			commit('SET_SPLIT', data.payload);
			commit('SET_CURRENT_ID', data.payload.id);
			commit('SET_LOADING', false);
		},
		async post ({ commit }, request: CampaignSplitRequest) {
			commit('SET_LOADING', true);
			const { data } = await api.post('/campaign-split', request);
			commit('SET_SPLIT', data.payload);
			commit('SET_CURRENT_ID', data.payload.id);
			commit('SET_LOADING', false);
			return data.payload;
		},
		async update ({ commit }, { id, ...request }: { id: number } & CampaignSplitRequest) {
			commit('SET_LOADING', true);
			const { data } = await api.put(`/campaign-split/${ id }`, request);
			commit('SET_SPLIT', data.payload);
			commit('SET_CURRENT_ID', data.payload.id);
			commit('SET_LOADING', false);
			return data.payload;
		},
		async approve ({ commit }, id: number) {
			commit('SET_LOADING', true);
			const { data } = await api.post(`/campaign-split/${ id }/approve`);
			commit('SET_SPLIT', data.payload);
			commit('SET_CURRENT_ID', data.payload.id);
			commit('SET_LOADING', false);
			return data.payload;
		},
		async getDistributionList (_context, { id, ...params }: { id: number } & GetCampaignSplitIdDistributionListParams) {
			const { data } = await api.get(`/campaign-split/${ id }/distribution-list`, { params });
			return data.payload;
		},
		async getEghDistributionList (_context, { id, ...params }: { id: number } & GetCampaignSplitIdDistributionListEghParams) {
			const { data } = await api.get(`/campaign-split/${ id }/distribution-list-egh`, { params });
			return data.payload;
		},
		async getFromInterval ({ commit }, { from, to }: { from: string; to: string }) {
			commit('SET_LOADING', true);
			const params: GetCampaignSplitParams = { from, to, limit: 1, offset: 0 };
			const { data } = await api.get('/campaign-split', { params });
			const existing = data.payload[0];
			if (existing != null) {
				commit('SET_SPLIT', existing);
			}
			commit('SET_CURRENT_ID', existing?.id ?? null);
			commit('SET_LOADING', false);
		},
	});


